import { getQueryStringFromRequest } from './url-utils';

export type SpecialRedirectMatch = {
    to: string;
    code: number;
};

const SFCC_RECIPE_CONTROLLER_PATH_PREFIX = '/on/demandware.store/Sites-SLT-Site/default/';

const buildRecipeControllerRedirectFromSearch = (
    pathname: string,
    search: string,
): SpecialRedirectMatch | null => {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    const pid = params.get('pid');

    if (!pid || !pid.startsWith('REC-')) {
        return null;
    }

    const lastSlashIndex = pathname.lastIndexOf('/');
    const recipeName = lastSlashIndex === -1 ? pathname : pathname.slice(lastSlashIndex + 1);
    const recipeSku = pid;

    params.delete('pid');
    const qs = params.toString();

    return {
        to: `/recipe/${recipeName}/${recipeSku}${qs ? `?${qs}` : ''}`,
        code: 301,
    };
};

export const getSpecialRedirectMatch = (
    pathname: string,
    search: string,
): SpecialRedirectMatch | null => {
    if (!pathname.startsWith(SFCC_RECIPE_CONTROLLER_PATH_PREFIX)) {
        return null;
    }

    return buildRecipeControllerRedirectFromSearch(pathname, search);
};

type RequestWithPath = {
    path?: string;
};

export const getSpecialRedirectMatchFromRequest = (
    req: RequestWithPath | undefined,
): SpecialRedirectMatch | null => {
    if (!req || !req.path || !req.path.startsWith(SFCC_RECIPE_CONTROLLER_PATH_PREFIX)) {
        return null;
    }

    const qs = getQueryStringFromRequest(req as Parameters<typeof getQueryStringFromRequest>[0]);

    return buildRecipeControllerRedirectFromSearch(req.path, qs);
};
